import { render, staticRenderFns } from "./TemplateHeader.vue?vue&type=template&id=06dec8e8&scoped=true&"
import script from "./TemplateHeader.vue?vue&type=script&lang=js&"
export * from "./TemplateHeader.vue?vue&type=script&lang=js&"
import style0 from "./TemplateHeader.vue?vue&type=style&index=0&id=06dec8e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dec8e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDivider,VIcon})
